export default {"src":"/_next/static/media/sauna.13e55581.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};